import styled from 'styled-components';

// replicated from chakra-ui: https://github.com/chakra-ui/chakra-ui/blob/main/packages/visually-hidden/src/visually-hidden.tsx
export const VisuallyHidden = styled.span`
  border: 0px;
  clip: rect(0px, 0px, 0px, 0px);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0px;
  overflow: hidden;
  white-space: nowrap;
  position: absolute;
`;

export default VisuallyHidden;
